<template>
    <div class="form-group">
        <label class="file-label" :for="id">{{ label }}</label>

        <input
            type="file"
            :id="id"
            :name="name"
            @change="onChange($event)"
        >

        <div class='file-buttons'>
            <label class="file-button" :for="id" style="position: relative; ">
                <div>
                    <span
                        :style="[{'width': `${uploadPercentage}%`}]"
                        :class="{'no-padding': uploadPercentage == 0}"
                        style="position: absolute;
                            background-color: #2C4155;
                            padding: 13px 16px;
                            margin-left: -16px;
                            margin-top: -12px;
                            border-radius: 4px;
                            color:white;
                            opacity: 0.7;
                            text-align: center;
                            transition: width 0.3s linear;"
                    ><p style="color:white;" v-if="uploadPercentage !== 0">{{uploadPercentage}}%</p></span>
                </div>
                <div>
                    <i class="fas fa-upload"></i><span> {{ placeholder }} </span>
                </div>
            </label>

            <a class='file-download-button' :class="{'disabled': value === ''}" @click='downloadFile'>
                <i class="fas fa-download"></i>
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'UploadInput',

    props: {
        label: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            required: true,
        },

        name: {
            type: String,
        },

        value: {
            type: String,
            default: '',
        },

        uploadPercentage: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            file: null,
        };
    },

    methods: {
        onChange(event) {
            this.file = event.target.files[0];
            this.$emit('change', this.file);
        },

        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },

        submitFile() {
            this.$emit('change', this.file);
        },

        downloadFile() {
            if (this.value) {
                this.$emit('download');
            }
        },
    },

    computed: {
        placeholder() {
            let placeholder = this.$translate.text('general.file.choose');

            if (this.file !== null) {
                placeholder = this.file.name;
            } else if (this.value !== '') {
                placeholder = this.value;
            }

            return placeholder;
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
    display: flex;
    align-items: center;

    .file-label {
        color: $black;
        flex: 2;
    }

    .file-buttons {
        flex: 6;
        display: flex;
        margin-left: -8px;
    }

    .file-button {
        flex-grow: inherit;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;
        background-color: #5dbff9;
        color: white;
    }

    .file-button:hover {
        cursor: pointer;
        background-color: #67c4fc;
    }

    .file-download-button {
        width: 50px;
        margin-left: 6px;
        border: 0;
        border-radius: 4px;
        padding: 12px 16px;
        font-size: 16px;
        background-color: #5dbff9;
        color: white;
    }

    .file-download-button:hover {
        cursor: pointer;
        background-color: #67c4fc;
    }

    .file-download-button.disabled {
        cursor: not-allowed;
        opacity: .8;
    }

    .file-download-button.disabled:hover {
        cursor: not-allowed;
        background-color: #5dbff9;
    }

    input {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .file-image-wrapper {
        flex: 6;
        padding: 12px 16px;
        position: relative;

        img {
            max-width: 150px;
        }

        button {
            background: none;
            border: 0;
            cursor: pointer;
            font-size: 28px;
            color: grey;
            position: absolute;
            left: 180px;
            top: 0;
        }
    }
}

.no-padding {
    padding: 0px !important;
}
</style>
